import { TableColumn } from "components/table/Table";
import TableTruncate from "components/table/renderComponents/TableTruncate";
import TableImage from "components/table/renderComponents/TableImage";

export interface Data {
  _id: string;
  title: string;
  shortDescription: string;
  slug: string;
  banner: string;
  content: Record<string, any>;
  listOrderNumber: number;
  language: string;
  author: string;
  categoryIds: string[];
  createdAt: string;
}

export const columns: TableColumn<Data>[] = [
  {
    key: "_id",
    label: "id",
    sortable: true,
    render: (item: Data) => <TableTruncate text={item._id} withCopy />,
  },
  {
    key: "title",
    label: "title",
    sortable: true,
    render: (item: Data) => <TableTruncate text={item.title} />,
  },
  {
    key: "shortDescription",
    label: "shortDescription",
    sortable: true,
    render: (item: Data) => <TableTruncate text={item.shortDescription} />,
  },
  {
    key: "slug",
    label: "slug",
    sortable: true,
    render: (item: Data) => <TableTruncate text={item.slug} withCopy />,
  },
  {
    key: "banner",
    label: "banner",
    sortable: false,
    render: (item: Data) => <TableImage image={item.banner} />,
  },
  {
    key: "listOrderNumber",
    label: "listOrderNumber",
    sortable: true,
    render: (item: Data) => <p>{item?.listOrderNumber}</p>,
  },
  {
    key: "language",
    label: "language",
    sortable: true,
    render: (item: Data) => <p>{item.language}</p>,
  },
  {
    key: "author",
    label: "author",
    sortable: true,
    render: (item: Data) => <TableTruncate text={item.author} />,
  },
  {
    key: "categoryIds",
    label: "categories",
    sortable: false,
    render: (item: Data) => (
      <div className="flex flex-wrap gap-1">
        {item.categoryIds?.map((id) => (
          <span
            key={id}
            className="px-2 py-0.5 text-xs rounded bg-gray-100 text-gray-700"
          >
            {id}
          </span>
        ))}
      </div>
    ),
  },
  {
    key: "createdAt",
    label: "createdAt",
    sortable: true,
    render: (item: Data) => (
      <p>{new Date(item.createdAt).toLocaleDateString()}</p>
    ),
  },
];
